import React, { useState } from "react";
//import { useTypewriter } from "react-simple-typewriter";
import axios from 'axios';
import {toast} from 'react-toastify';
import imgBack from "../../../src/images/mailz.jpeg";
import load1 from "../../../src/images/load2.gif";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./ContactUs.css";
import FooterInfo from "../Footer/FooterInfo";

function ContactUs(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;

    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [banner, setBanner] = useState("");
  const [bool, setBool] = useState(false);
  const [acceptedPolicy, setAcceptedPolicy] = useState(false);

  const handleName = (e) => {
    setName(e.target.value)
  }
  const handlEmail = (e) => {
    setEmail(e.target.value)
  }
  const handleMessage = (e) => {
    setMessage(e.target.value)
  }

  const submitForm = async (e) => {
  e.preventDefault();

  if (!acceptedPolicy) {
    setBanner("Molimo da prihvatite politiku privatnosti prije slanja.");
    toast.error("Morate prihvatiti obradu podataka.");
    return;
  }

  try {
    let data = { name, email, message };
    setBool(true);

    const res = await axios.post(`/contact`, data);

    if (name.length === 0 || message.length === 0 || email.length === 0) {
      setBanner(res.data.msg);
      toast.error(res.data.msg);
      setBool(false);
    } else if (res.status === 200) {
      setBanner(res.data.msg);
      toast.success(res.data.msg);
      setBool(false);
      setName("");
      setEmail("");
      setMessage("");
      setAcceptedPolicy(false);
    }
  } catch (error) {
    console.log(error);
  }
};


  return (
    <div className="main-container fade-in" id={props.id || ""}>
      <ScreenHeading subHeading={"Pošaljite mejl"} title={"Kontaktirajte nas"} />

      <div className="central-form">
        <div className="col">
          <h2 className="title">{" Zatražite ponudu"}</h2>
          <a href="https://www.facebook.com/profile.php?id=61573389059672">
              <i className="fa fa-facebook-square"></i>
            </a>
            <a href="https://www.instagram.com/magna.doo/">
              <i className="fa fa-instagram"></i>
            </a>
        </div>
        <div className="back-form">
            <div className="img-back">
                <h4>Vaši podaci se traže isključivo zbog poboljšanja odgovora na vašu poruku.</h4>
                <img src={imgBack} alt="image not found" />
            </div>
            <form onSubmit={submitForm}>
                <p>{banner}</p>
                <label htmlFor="name">Ime</label>
                <input 
                type="text"
                onChange={handleName}
                value={name}
                />

                <label htmlFor="email">Email</label>
                <input 
                type="email"
                onChange={handlEmail}
                value={email}
                />

                <label htmlFor="message">Poruka</label>
                <textarea 
                type="text"
                onChange={handleMessage}
                value={message}
                />
                <div className="checkbox-wrapper">
  <input
    type="checkbox"
    id="privacyCheck"
    checked={acceptedPolicy}
    onChange={(e) => setAcceptedPolicy(e.target.checked)}
  />
  <label htmlFor="privacyCheck">
    Saglasan/a sam sa obradom ličnih podataka u skladu sa Politikom privatnosti.
  </label>
</div>

                <div className="send-btn">
                    <button type="submit" disabled={!acceptedPolicy}>
  Pošalji 
  <i className="fa fa-paper-plane" />
  {bool ? (<b className="load"><img src={load1} alt="not responding" /></b>) : ("")}
</button>

                    
                </div>
            </form>
        </div>
      </div>
      <FooterInfo />
    </div>
  );
}

export default ContactUs;
